import { render } from "./RegisterSmallLight.vue?vue&type=template&id=fecd8844&scoped=true&ts=true"
import script from "./RegisterSmallLight.vue?vue&type=script&lang=ts"
export * from "./RegisterSmallLight.vue?vue&type=script&lang=ts"

import "./RegisterSmallLight.vue?vue&type=style&index=0&id=fecd8844&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Administrator\\Documents\\Repos\\PROD-license-management\\redesign\\WebUI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fecd8844"]])

export default __exports__